import { useRef } from 'react';

import { useLegalClientBeneficiarySaveCitizenships } from 'api/requests/onboarding/legal/beneficiary';
import { useServerErrorNotify } from 'hooks';
import { OnboardingCitizenshipFormType } from 'modules/onboarding/common/forms/onboardingCitizenshipForm';
import { getInitialData } from 'modules/onboarding/common/helpers/citizenship/getInitialData';
import { getSubmitData } from 'modules/onboarding/common/helpers/citizenship/getSubmitData';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useCitizenship = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    saveCitizenships,
    loading: submitLoading,
    error,
  } = useLegalClientBeneficiarySaveCitizenships();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialValues = useRef(
    getInitialData(data.legalClientBeneficiary.citizenships)
  ).current;

  const onSubmit = async (values: OnboardingCitizenshipFormType) => {
    if (values.citizenships) {
      const submitData = getSubmitData(values);
      await saveCitizenships(
        data.legalClient.id,
        data.legalClientBeneficiary.id,
        submitData
      );
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    submitLoading,
    initialValues,
    countries,
    countriesLoading,
    goToBack,
  };
};
